document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.tab-link');
  const panes = document.querySelectorAll('.tab-pane');

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      // Remove active classes
      tabs.forEach(t => t.classList.remove('active'));
      panes.forEach(p => p.classList.remove('active'));

      // Add active class to selected tab and pane
      tab.classList.add('active');
      document.querySelector(`#${tab.getAttribute('data-tab')}`).classList.add('active');
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.details-menu-main').forEach(menu => {
        menu.addEventListener('click', () => {
            const subMenu = menu.querySelector('.menu_sub_menu');
            if (subMenu) {
                subMenu.classList.toggle('visible'); // Add or toggle a class
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.nav-tab');
    const navSections = document.querySelectorAll('.menu-drawer__navigation');

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const targetId = tab.dataset.target;

            // Remove active class from all tabs and hide all nav sections
            tabs.forEach(t => t.classList.remove('active'));
            navSections.forEach(nav => nav.classList.remove('active'));

            // Add active class to the clicked tab and show the corresponding nav section
            tab.classList.add('active');
            document.getElementById(targetId).classList.add('active');
        });
    });
});


// document.addEventListener("DOMContentLoaded", function () {
//   const toggleBtn = document.querySelector(".view-toggle-btn");
//   const gridView = document.querySelector(".product-grid-grid-view");
//   const listView = document.querySelector(".product-grid-list-view");

//   // Function to toggle views by adding/removing active classes
//   const toggleView = () => {
//     const currentView = toggleBtn.getAttribute("data-view");

//     if (currentView === "grid") {
//       // Switch to List View
//       gridView.classList.remove("active");
//       listView.classList.add("active");
//       toggleBtn.setAttribute("data-view", "list");
//       toggleBtn.classList.remove("grid");
//       toggleBtn.classList.add("list");
//       toggleBtn.textContent = "List View";
//     } else {
//       // Switch to Grid View
//       gridView.classList.add("active");
//       listView.classList.remove("active");
//       toggleBtn.setAttribute("data-view", "grid");
//       toggleBtn.classList.remove("list");
//       toggleBtn.classList.add("grid");
//       toggleBtn.textContent = "Grid View";
//     }
//   };

//   // Add click event listener to the button
//   toggleBtn.addEventListener("click", toggleView);

//   // Set initial state (default to Grid View)
//   gridView.classList.add("active");
//   listView.classList.remove("active");
// });


// Collection Page List View Grid View
window.grid_multiple_fun = function() {
    document.querySelector('.grid_multiple').classList.add('open');
    document.querySelector('.grid_single').classList.remove('open');
    document.querySelector('.product-grid-grid-view').classList.add('active');
    document.querySelector('.product-grid-list-view').classList.remove('active');
}

window.grid_single_fun = function() {
    document.querySelector('.grid_single').classList.add('open');
    document.querySelector('.grid_multiple').classList.remove('open');
    document.querySelector('.product-grid-list-view').classList.add('active');
    document.querySelector('.product-grid-grid-view').classList.remove('active');
}


window.checkGrids = function() {
  if (document.querySelectorAll('.grid_multiple').length > 0) {
    if (sessionStorage.getItem("grid-multiple") === 'true') {
      window.grid_multiple_fun();
    }

    document.addEventListener('click', function(event) {
      if (event.target.closest('.grid_multiple')) {
        window.grid_multiple_fun();
        sessionStorage.setItem("grid-multiple", true);
        sessionStorage.setItem("grid-single", null);
      }
    });
  }

  if (document.querySelectorAll('.grid_single').length > 0) {
    if (sessionStorage.getItem("grid-single") === 'true') {
      window.grid_single_fun();
    }

    document.addEventListener('click', function(event) {
      if (event.target.closest('.grid_single')) {
        window.grid_single_fun();
       
        sessionStorage.setItem("grid-single", true);
        sessionStorage.setItem("grid-multiple", null);
      }
    });
  }

  var rightAccordionArrow = document.querySelector(".active-facets-vertical-filter");
  var filtersLeftbar = document.querySelector("#FacetsWrapperDesktop");

  if (rightAccordionArrow) {
    rightAccordionArrow.onclick = function() {
      filtersLeftbar.classList.toggle('open');
    };
  }
}

window.checkGrids();

